import { motion } from "framer-motion";

const featureHighlights = [
  "Real-Time Analytics",
  "AI Waiter Agent",
  "Multi-Branch Support",
  "Dietary Filtering",
  "Bilingual Menus",
  "Engagement Tracking",
  "Comprehensive Item Details",
  "Customer Feedback Collection"
];

const FeatureHighlightsCarousel = () => {
  return (
    <section className="flex overflow-x-hidden w-full py-16 bg-white border-y-2 border-orange-100">
        <motion.div 
          initial={{ x: '0%' }} 
          animate={{ x: '-100%' }} 
          transition={{ duration: 45, ease: "linear", repeat: Infinity }} 
          className='flex items-center pr-8 gap-8 whitespace-nowrap'
        >
          {featureHighlights.map((feature, i) => (
            <div
              className={`inline-flex items-center px-6 py-3 rounded-full text-lg font-semibold ${
                i % 2 === 0 
                  ? "bg-white text-orange-600 border-2 border-orange-200 shadow-sm" 
                  : "bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25"
              }`}
              key={feature + i}
            >
              {feature}
            </div>
          ))}
        </motion.div>
        <motion.div 
          aria-hidden 
          initial={{ x: '0%' }} 
          animate={{ x: '-100%' }} 
          transition={{ duration: 45, ease: "linear", repeat: Infinity }} 
          className='flex items-center pr-8 gap-8 whitespace-nowrap'
        >
          {featureHighlights.map((feature, i) => (
            <div
              className={`inline-flex items-center px-6 py-3 rounded-full text-lg font-semibold ${
                i % 2 === 0 
                  ? "bg-white text-orange-600 border-2 border-orange-200 shadow-sm" 
                  : "bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg shadow-orange-500/25"
              }`}
              key={feature + "-repeat-" + i}
            >
              {feature}
            </div>
          ))}
        </motion.div>
    </section>
  );
};

export default FeatureHighlightsCarousel;